import { Component, Input } from '@angular/core';
import { ScrubberDataService } from 'src/app/services/scrubber-data.service';
import { CriminalRecordStatuteBatchRow } from '../../models/batch-row';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ChargeOpsModalComponent } from '../charge-ops-modal/charge-ops-modal.component';
import { ApplicantDataService } from 'src/app/services/applicant-data.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-charge-data-list',
  templateUrl: './charge-data-list.component.html',
  styleUrls: ['./charge-data-list.component.less']
})
export class ChargeDataListComponent {
  loading: boolean = false;
  descSearch : string;
  @Input() state : string;
  _selectedRow : CriminalRecordStatuteBatchRow;
  lastKey : any = {
    key : 'chargeDescription',
    ascending : false
  };
  
  constructor(public scrubs : ScrubberDataService, public modalService: NgbModal, public appData : ApplicantDataService, public toast : ToastrService){}
  
  public get chargesToWork() : CriminalRecordStatuteBatchRow[] {
    if(this.scrubs._chargesToWork){
      if(this.descSearch) {
        return this.appData.sortByKey(this.scrubs._chargesToWork.filter((str: CriminalRecordStatuteBatchRow) => { 
          return str.chargeDescription.toLowerCase().indexOf(this.descSearch.toLowerCase()) !== -1; 
        }),this.lastKey.key,this.lastKey.ascending);
      }
      return this.appData.sortByKey(this.scrubs._chargesToWork,this.lastKey.key,this.lastKey.ascending);
    }
  }

  sort(key : string){
    if(this.lastKey.key == key){
      this.lastKey.ascending = !this.lastKey.ascending;
    }else{
      this.lastKey.key = key;
      this.lastKey.ascending = false;
    }
  }
  
  clearChargeFromGroup(chrg : CriminalRecordStatuteBatchRow){
    this.scrubs.clearChargeFromStatuteGroup(chrg.statuteId, chrg.id).subscribe(()=>{
      this.scrubs.loadCharges(this.state,chrg.statuteId);
    }, () => {
      this.toast.error('Error clearing charge from group.');
    })
    console.log(chrg);
  }

  selectRecord(e : any, i : number){
    const modalRef = this.modalService.open(ChargeOpsModalComponent, { windowClass : 'bigAssModal'});
    modalRef.componentInstance.name = 'ChargeOpsModalComponent';
    modalRef.componentInstance.chrg = e;
  }
}
